import { isCustomerFromGensler } from '@mb/lib/customer';

import { formatImageSource } from '../../../helpers';
import { ProductSearchMaterial } from '../../../types';
import { isSearchPage } from '../../../utils/helpers';
import { buildAnalyticsParamsToPDP } from '../../../utils/helpers/analytics';
import { individualToggle } from '../../Filter/FamilyViewSwitch';

export const isSearch = isSearchPage();
export const isGenslerUser = isCustomerFromGensler();

export function getSubCategoryToShow(product: ProductSearchMaterial) {
  const availableSubcategories: string[] =
    product.categories?.filter((item: string) => item.includes('>')) ?? [];
  const firstSubcategory = availableSubcategories?.[0]?.split('>')?.pop();
  const lastSubcategory = availableSubcategories?.[
    availableSubcategories.length - 1
  ]
    ?.split('>')
    ?.pop();
  const subcategoryToShow = product.categories?.includes(firstSubcategory || '')
    ? lastSubcategory
    : firstSubcategory;

  if (subcategoryToShow != null) {
    return subcategoryToShow;
  }

  return product.categories?.[0];
}

export function getMaterialUrl(
  product: ProductSearchMaterial,
  itemId: number | string,
  urlPrefix: string,
  itemListId?: string,
  itemListName?: string,
  index?: number,
  searchToggle?: string,
) {
  const isFinishMaterial = product?.isFinish;
  let materialUrl: string;
  const pdpTrackParams: string = buildAnalyticsParamsToPDP({
    product,
    itemListId,
    itemListName,
    index: index !== undefined ? index + 1 : undefined,
  });

  const { colorwayId, isCollection, url } = product;

  if (colorwayId != null) {
    materialUrl = `${product.url}?activeChild=${colorwayId}&${pdpTrackParams}`;
  } else if (
    searchToggle === individualToggle ||
    isFinishMaterial ||
    !isCollection
  ) {
    materialUrl = `${url}?activeChild=${itemId}&${pdpTrackParams}`;
  } else {
    materialUrl = `${url}?${pdpTrackParams}`;
  }

  materialUrl = `${urlPrefix}${materialUrl}`;
  return materialUrl;
}

export function getImageUrl(thumbnail: string, imageSize: number) {
  // image from API comes with get param ?width=X, we need to replace that
  // to adjust size to column size
  const defaultSizeImage = thumbnail?.split('?')?.[0];
  const finalImageSize = Math.max(424, imageSize);
  const finalUrl = defaultSizeImage
    ? formatImageSource(defaultSizeImage, finalImageSize, false)
    : null;
  return finalUrl?.src || '';
}
